import React, { lazy, Suspense, useEffect, useMemo } from 'react';
import {
  Route, Switch, Redirect, useLocation,
} from 'react-router-dom';
import { connect } from 'react-redux';

import { getCookie, setCookie } from 'helpers/cookies';
// import { setVisits, setClientDecision } from 'services/user.services';

import PrivateRoute from 'containers/PrivateRoute';
const HomeContainer = lazy(() => import(/* webpackChunkName: "route-home" */ 'containers/HomeContainer'));
const ProductsContainer = lazy(() => import(/* webpackChunkName: "route-products" */ 'containers/ProductsContainer'));
const OffersContainer = lazy(() => import(/* webpackChunkName: "route-offers" */ 'containers/OffersContainer'));
const MostSelledContainer = lazy(() => import(/* webpackChunkName: "route-most-sold" */ 'containers/MostSelledContainer'));
const ProductSingleContainer = lazy(() => import(/* webpackChunkName: "route-product" */ 'containers/ProductSingleContainer'));
const SearchProductContainer = lazy(() => import(/* webpackChunkName: "route-search" */ 'containers/SearchProductContainer'));
const ContactContainer = lazy(() => import(/* webpackChunkName: "route-contact" */ 'containers/ContactContainer'));
const CartContainer = lazy(() => import(/* webpackChunkName: "route-cart" */ 'containers/CartContainer'));
const DeliveryContainer = lazy(() => import(/* webpackChunkName: "route-delivery" */ 'containers/DeliveryContainer'));
const PickupContainer = lazy(() => import(/* webpackChunkName: "route-pickup" */ 'containers/PickupContainer'));
const ProfileContainer = lazy(() => import(/* webpackChunkName: "route-profile" */ 'containers/ProfileContainer'));
const PurchaseHistoryContainer = lazy(() => import(/* webpackChunkName: "route-purchases" */ 'containers/PurchaseHistoryContainer'));
const CatalogueContainer = lazy(() => import(/* webpackChunkName: "route-catalogue" */ 'containers/CatalogueContainer'));
const FrequentQuestions = lazy(() => import(/* webpackChunkName: "route-faq" */ 'views/FrequentQuestions'));
const SuccessfulPurchaseContainer = lazy(() => import(/* webpackChunkName: "route-purchase-success" */ 'containers/SuccessfulPurchaseContainer'));
const Error = lazy(() => import(/* webpackChunkName: "route-error" */ 'views/Error'));
const PricesContainer = lazy(() => import(/* webpackChunkName: "route-prices" */ './PricesContainer'));
const VerifyEmailContainer = lazy(() => import(/* webpackChunkName: "route-verify-email" */ 'containers/VerifyEmailContainer'));
const ResetPassEmailContainer = lazy(() => import(/* webpackChunkName: "route-reset-password" */ 'containers/ResetPassEmailContainer'));
const TrackingGuideContainer = lazy(() => import(/* webpackChunkName: "route-tracking" */ 'containers/TrackingGuideContainer'));
const SellerDashboardContainer = lazy(() => import(/* webpackChunkName: "route-seller" */ 'containers/SellerDashboardContainer'));

const useQuery = () => {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
};

const NavigationContainer = ({envios, modules = null}) => {
  const query = useQuery();
  
  const tieneEnvios = envios && envios.length > 0;

  useEffect(() => {
    const updateCookies = async () => {
      try {
        let date = new Date();
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        date = `${year}-${month}-${day}`;
        const platform = query.get('platform') || 0;
        const key = `_plat_${platform}`;
        if (getCookie(key) !== date) {
          setCookie(key, date, { maxAge: 86400 });
          // const data = { date, platform, isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) };
          // await setVisits(data);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    };

    // const clientDecision = async () => {
    //   try {
    //     const response = await setClientDecision();
    //     setCookie('visits_purcharse', response.visit.id, { maxAge: 86400 });
    //   } catch (error) {
    //     // eslint-disable-next-line no-console
    //     console.log(error);
    //   }
    // };

    updateCookies();
    // clientDecision();
    // eslint-disable-next-line
  }, []);

  return (
    <Suspense fallback={<div className="route-loading" role="status" aria-live="polite">Cargando…</div>}>
      <Switch>
        <Redirect exact from="/" to="/home" />
        <Route path="/home/:section?" component={HomeContainer} />
        <Route path="/productos/:category?/:subCategory?" component={ProductsContainer} />
        <Route path="/ofertas/:category?/:subCategory?" component={OffersContainer} />
        <Route path="/hot-sale/:category?" component={OffersContainer} />
        <Route path="/masVendido/:category?/:subCategory?" component={MostSelledContainer} />
        <Route path="/producto/:product(.*)" component={ProductSingleContainer} />
        <Route path="/busqueda/:search/:category?" component={SearchProductContainer} />
        <Route path="/contacto" component={ContactContainer} />
        <Route path="/carrito" component={CartContainer} />
        <Route
          path="/envio-a-domicilio"
          render={(props) => tieneEnvios
            ? <DeliveryContainer {...props} />
            : <Redirect to="/carrito" />
          }
        />
        <Route path="/retiro-en-sucursal" component={PickupContainer} />
        <Route path="/preguntas-frecuentes" component={FrequentQuestions} />
        <Route path="/catalogos" component={CatalogueContainer} />
        <Route path="/precios" component={PricesContainer} />
        <Route path="/compra-exitosa/:guideNumber?" component={SuccessfulPurchaseContainer} />
        <Route path="/seguimiento-de-envio/:guideNumber" component={TrackingGuideContainer} />
        <Route path="/verify-email" component={VerifyEmailContainer} />
        <Route path="/verify-password" component={ResetPassEmailContainer} />
        <PrivateRoute path="/perfil" component={ProfileContainer} />
        <PrivateRoute path="/compras" component={PurchaseHistoryContainer} />
        {modules && modules.seller === false
          ? <Redirect exact from="/vendedor" to="/home" />
          : <PrivateRoute path="/vendedor" component={SellerDashboardContainer} />}
        <Route component={Error} />
      </Switch>
    </Suspense>
  );
};

const mapStateToProps = (state) => ({
  envios: state.app.envios,
  modules: state.app.modules,
});

export default connect(mapStateToProps)(NavigationContainer);
